module.exports = __webpack_public_path__ + "img/IMG_9458_59_60_L_Wood_MockedUp.d4f50c54.jpg";